import toRadian from 'helpers/toRadian'
import calculateVertex from 'components/Camera/helpers/calculateVertex'

export default function calculateBoundPoints({ originAngle, bound, closer, cameraMarkerPosition, heading, distance, paths: { endAngle } }) {
  // check if bound is actually inside the desired PPF zone
  if (bound < distance && bound > 0) {
    const innerAngle = calculateVertex({ angle: originAngle, distance: bound, heading, cameraMarkerPosition, showAnalyticZones: true })

    // order of paths matters
    return innerAngle
  } else return closer ? [cameraMarkerPosition] : endAngle.slice().reverse()
}



// WEBPACK FOOTER //
// ./src/components/Camera/helpers/calculateBoundPoints.js